export const TYPES = {
	SET_RESPONSIVE: 	'SET_RESPONSIVE',
	SET_LANGUAGES: 		'SET_LANGUAGES',
	SET_CURRENCIES: 	'SET_CURRENCIES',
};
